(() => {
  const preservePreviewTheme = () => {
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!previewThemeId) return;
    document.querySelectorAll('a[href^="/?view=pt-"]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };
  preservePreviewTheme();
  document.addEventListener('shopify:section:load', preservePreviewTheme);
})();
